// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Toolbar } from '@mui/material';
import { Sidebar } from '../components/Sidebar/Sidebar';
import { useIsSmall } from '../hooks/other/useIsSmall';
import { containerSx, mainContentSx } from '../modules/styles';
import { ModuleRoute } from '../routes/types';

interface CommonUtilitiesLayoutProps {
  entries: ModuleRoute[];
  children: React.ReactNode;
}
export const CommonUtilitiesLayout: React.FC<CommonUtilitiesLayoutProps> = ({
  entries,
  children,
}) => {
  const isSmall = useIsSmall();
  return (
    <Box sx={containerSx}>
      {!isSmall && <Sidebar routes={entries} />}
      <Box sx={mainContentSx}>
        {isSmall && <Toolbar />}

        {children}
      </Box>
    </Box>
  );
};
